// @flow
import {
  captureException as originalCaptureException,
  captureMessage,
  configureScope,
  showReportDialog,
  withScope,
} from '@sentry/browser';
import type { ErrorContext } from '@rover/react-lib/types/ErrorContext';

const captureException = (error: Error, errorContext?: ErrorContext) => {
  withScope(scope => {
    if (error.message) {
      // Force deduplication by error message
      scope.setFingerprint([error.message]);
    }

    if (errorContext) {
      const { res, errorInfo, query, pathname } = errorContext;

      scope.setExtras({
        ...(res && res.statusCode && { statusCode: res.statusCode }),
        ...errorInfo,
        query,
        pathname,
      });
    }

    originalCaptureException(error);
  });
};

export { captureException, captureMessage, configureScope, showReportDialog, withScope };



// WEBPACK FOOTER //
// ../utilities/sentry.client.js